module.exports = __webpack_public_path__ + "static/logo-7dba803441ec11a5b27d20ef277eedef.png";